var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"img-right":"","title":_vm.t('Manuals.integration')}})}
var staticRenderFns = []

export { render, staticRenderFns }